<!-- <div [innerHTML]="htmlContent"></div> -->
<form *ngIf="conf.Groups.length > 0" #dynamicForm="ngForm" [ngClass]="{ 'readonly':ReadOnly==true}">
  <div *ngFor="let group of conf.Groups">
    <div class="labelHead">
      {{ group.GroupName }}
      <button class="btn btn-secondary add-field-btn" *ngIf="group.IsMultiple && group.multipleOptions.options.length>0"
        (click)="openModal(group)">
        + Add
      </button>
      <!-- <button class="btn btn-secondary add-field-btn" *ngIf="group.IsMultiple && !group.multipleOptions.options.length==0" (click)="addNewFieldGroup(group)">
        + Add
      </button> -->
      <div [ngStyle]="{ display: display }">
        <div class="modal" [ngStyle]="{ display: display }">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="width: 290px; height: 301px">
              <div class="modal-header menu" style="border-radius: 0">
                <span class="menu-heading"> Choose a {{modalGroupObj?.GroupName}} type:</span>
                <span class="close" (click)="onCloseHandled(modalGroupObj)">X</span>
              </div>
              <div class="modal-body">
                <div class="form-check mb-2" *ngFor="let opt of modalGroupObj?.multipleOptions.options; let i = index"
                  (change)="onMultipleOptionChange(opt, modalGroupObj)">
                  <input class="form-check-input" style="border: 0.125rem solid #2f78c4; border-radius: 0.125rem"
                    type="checkbox" value=" " [checked]="opt.Selected" id="defaultCheck-{{ i }}" />
                  <label class="form-check-label" for="defaultCheck-{{ i }}" style="
                      text-align: left;
                      font: normal normal medium 0.938rem/1.125rem Gellix;
                      font-weight: medium;
                      font-size: 0.938rem;
                      line-height: 1.125rem;
                      letter-spacing: 0rem;
                      color: #000048;
                      opacity: 1;
                    ">
                    {{ opt.name }}
                  </label>
                  <span class="star" *ngIf="field.isRequired"> *</span>
                </div>
              </div>
              <div class="modal-footer" style="justify-content: center">
                <button type="button" [ngClass]="'done-btn-active'" (click)="onAddMultipleOption(modalGroupObj)">
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span (click)="editForm()" *ngIf="group.GroupName === 'Basic Information'">
        <img alt src="{{ baseHref }}/assets/images/icon-eye.svg" class="floatRight" />
      </span>
    </div>
    <hr class="hrRow" />

    <!--
    Field Types:
    ShortText
    TextArea*
    CheckBox*
    RadioButton*
    DropDown*
    Input*
    Hidden
    CheckBoxGroup
    CheckBoxGroupWithOther
    Password*
    MultiSelect*
    DatePicker*
    DateTimePicker*
    ChilkablePhoneNumber
    UserPicker
    CaseUserPicker
    FIlePicker
    CaseAssigner
  -->
    <div class="row">

      <ng-container *ngFor="let field of group.Fields">
        <ng-container *ngIf="field.fieldType === 'Input' && field.show">
          <div class="col-3 form-row input-data">
            <label for="{{ field.Name }}">{{ field.Label }} <span class="star" *ngIf="field.isRequired"
                [hidden]="field.viewMode"> *</span></label>
            <input [id]="field.fieldID" [name]="field.Name" [value]="getModel(group, field)"
              [required]="field.isRequired" [ngClass]="field.viewMode ? 'read-only' : ''" [pattern]="field.pattern"
              [attr.maxlength]="field.maxLength" [attr.minlength]="field.minLength" [disabled]="field.isDisabled"
              [attr.type]="field.isEmail ? 'email' : 'text'" (input)="onFormDataChange(group, field, $event)" />
            <div class="underline-fixed" [hidden]="field.viewMode"></div>

            <div class="text-danger" *ngIf="field.invalid">
              <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
              <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
              <small *ngIf="field.minlengthError">
                {{ field.Label }} must be at least {{ field.minLength }} characters</small>
              <small *ngIf="field.maxlengthError">
                {{ field.Label }} must be at most {{ field.maxLength }} characters</small>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="field.fieldType === 'Password' && field.show">
          <div class="col-3 form-row input-data">
            <label for="{{ field.Name }}">{{ field.Label }} <span class="star" *ngIf="field.isRequired"
                [hidden]="field.viewMode"> *</span></label>
            <input type="password" [id]="field.fieldID" [name]="field.Name" [disabled]="field.isDisabled"
              [value]="getModel(group, field)" [required]="field.isRequired"
              [ngClass]="field.viewMode ? 'read-only' : ''" [pattern]="field.pattern" [attr.maxlength]="field.maxLength"
              [attr.minlength]="field.minLength" (input)="onFormDataChange(group, field, $event)" />
            <div class="underline-fixed" [hidden]="field.viewMode"></div>

            <div class="text-danger" *ngIf="field.invalid">
              <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
              <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
              <small *ngIf="field.minlengthError">
                {{ field.Label }} must be at least {{ field.minLength }} characters</small>
              <small *ngIf="field.maxlengthError">
                {{ field.Label }} must be at most {{ field.maxLength }} characters</small>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="field.fieldType === 'DropDown' && field.show">
          <div class="col-3 form-row input-data">
            <label for="{{ field.Name }}">{{ field.Label }} <span class="star" *ngIf="field.isRequired"
                [hidden]="field.viewMode"> *</span></label>
            <select [ngModel]="getModel(group, field)" [name]="field.Name" [disabled]="field.isDisabled"
              [id]="field.fieldID" [required]="field.isRequired" [ngClass]="field.viewMode ? 'read-only' : ''"
              (change)="onDropDownChange(group, field, $event)">
              <option value="">Select One</option>
              <option *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'" value="{{ option.Value }}">
                {{ option.Name }}
              </option>
            </select>
            <div class="underline-fixed" [hidden]="field.viewMode"></div>
            <div class="text-danger" *ngIf="field.invalid">
              <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
              <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
              <small *ngIf="field.minLengthError">
                {{ field.Label }} must be at least {{ field.minLength }} characters
              </small>
              <small *ngIf="field.maxLengthError">
                {{ field.Label }} must be at most {{ field.maxLength }} characters</small>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="(field.fieldType === 'DatePicker' || field.fieldType === 'DateTimePicker') && field.show" style="width: 10rem">
          <div class="col-3 form-row input-data">
            <label for="{{ field.Name }}">{{ field.Label }} <span class="star" *ngIf="field.isRequired"> *</span></label>
            <input type="date" name="followUp" class="datetimepicker" [ngModel]="field.value | date: 'yyyy-MM-dd'"
              (ngModelChange)="field.value = $event" (change)="onFormDataChange(group, field, $event)"
              [value]="getModel(group, field)" [ngModelOptions]="{ standalone: true }" autocomplete="off"
              [disabled]="field.isDisabled" />

            <!-- <div class="underline-fixed"></div> -->
            <div class="text-danger" *ngIf="field.invalid">
              <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
              <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
              <small *ngIf="field.minLengthError">
                {{ field.Label }} must be at least {{ field.minLength }} characters
              </small>
              <small *ngIf="field.maxLengthError">
                {{ field.Label }} must be at most {{ field.maxLength }} characters</small>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="field.fieldType === 'Hidden'">
          <input class="hidden" type="hidden" [id]="field.fieldID" [name]="field.Name" [value]="getModel(group, field)">
        </ng-container>

        <ng-container  *ngIf="field.fieldType === 'CheckBoxGroup' && field.show">
          <div class="col-3 form-row input-data">
            <label for="{{field.Name}}">{{field.Label}}</label>
            <div class="heading" *ngFor="let option of field.fieldOptions;let i = index" style="min-width: 15rem;">
              <input
              class="form-check-input checkbox"
              type="checkbox"
              [value]="option.Value"
              (change)="onCheckboxChange($event, field, group)" 
              [checked]="field.value.includes(option.Value)"
              id="flexCheckDefault-{{i}}"
            />
            <label class="form-check-label checkbox-label" for="flexCheckDefault-{{i}}" style="color: #000">
              {{ option.Name }}
            </label>
            </div>
          </div>
        </ng-container>
        
      </ng-container>
    </div>
  </div>
</form>